import Vue from 'vue'
import vueI18n from 'vue-i18n'

import ccConsent from './plugins/consent'

Vue.use(vueI18n)
const i18nOptions = JSON.parse(document.getElementById('vue-i18n-data').innerHTML)
const i18n = new vueI18n(i18nOptions)

Vue.use(ccConsent, i18n)
// Vue.consent.waitForDecision()
window.consent = Vue.consent
window.consent.$i18n.locale = getLocale()
Vue.config.productionTip = false

initCC(window.consent)
//console.log("### Hier A.1")
//waitForDecision(window.consent);
//console.log("### Hier A.2");

console.log("### nach 'Initialisierung' des dataLyer")

function initCC(cconsent) {

    console.log("##-## initCC:: aufgerufen")

    window["dataLayer"] = window["dataLayer"] || []
    const consent = window.consent.getDecision()
    if (consent) {
        window.dataLayer.push({
            consentStatistics: consent.statistics,
            consentRetargeting: consent.other
        })
    }

    window["dataLayer"].push({
        event: "gtm.js",
        "gtm.start": new Date().getTime()
    });

//    if (options.googleTagManagerID) {
    let script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=GTM-M3GKPSQ`;
    document.body.appendChild(script);
//    }

    console.log("##-## initCC:: vor call von waitForDecision()")
    waitForDecision(cconsent)
    console.log("##-## initCC:: nach call von waitForDecision()")
}

function waitForDecision(cconsent) {

    console.log("##-## waitForDecision:: aufgerufen")

    cconsent
        .waitForDecision()
        .then(decision => {
            console.log("### waitForDecision() Entscheidung getroffen ->", decision);
            // this.loadTagManager(consent, true)
            window.dataLayer.push({
                event: "user consent",
                consentStatistics: decision.statistics,
                consentRetargeting: decision.other
            });
        })
        .finally(() => {
            console.log("##-## waitForDecision:: finally clause")
            waitForDecision(cconsent);
        });
    
    console.log("##-## waitForDecision:: Ende")
}

function getLocale() {
    const url = window.location.toString();
    const pos = url.indexOf("//");
    const start = url.indexOf("/", pos + 2);
    const end = url.indexOf("/", start + 1);
    const lang = url.slice(start + 1, end);
    return lang;
}
